<script setup>
import FlyoutMenu from '@elements/FlyoutMenu.vue'
import MenuItem from '@elements/MenuItem.vue'
import { computed, defineAsyncComponent } from 'vue'
import { useAuthorizationStore } from '@/stores/useAuthStore.js'
import { useI18n } from 'vue-i18n'
import { usePreferencesStore } from '@/stores/usePreferencesStore.js'

const UserGravatar = defineAsyncComponent(() => import('@elements/UserGravatar.vue'))
const UserAvatar = defineAsyncComponent(() => import('@elements/UserAvatar.vue'))

const auth = useAuthorizationStore()
const i18n = useI18n()
const preferences = usePreferencesStore()

const locale = computed(() => {
	const localeLanguages = {
		en: 'en-nl',
		nl: 'nl',
		fr: 'fr-fr'
	}
	return localeLanguages?.[i18n.locale] ?? ''
})
const user = auth.user
</script>

<template>
	<div class="user-menu">
		<FlyoutMenu position="bottom-end">
			<template #button>
				<UserAvatar
					v-if="preferences.get('gravatar') === '0'"
					:first-name="user?.first_name ?? ''"
					:last-name="user?.last_name ?? ''"
				/>
				<UserGravatar
					v-if="preferences.get('gravatar') === '1'"
					:email="user.email"
				/>
			</template>
			<template #items>
				<MenuItem
					:route="{ name: 'user.account' }"
					accesskey="a"
				>
					{{ i18n.t('auth.myAccount') }}
				</MenuItem>
				<MenuItem
					:route="{ name: 'user.preferences' }"
					accesskey="p"
				>
					{{ i18n.t('common.preferences', 0) }}
				</MenuItem>
				<li role="separator" />
				<MenuItem
					:link="{
						href: `https://normecfoodcareonline.zendesk.com/hc/${locale}`,
						target: '_blank'
					}"
					accesskey="h"
				>
					{{ i18n.t('common.help') }}
				</MenuItem>
				<MenuItem
					:link="{
						href: `https://normecfoodcareonline.zendesk.com/hc/${locale}/categories/5933900029980-Updates`,
						target: '_blank'
					}"
					accesskey="u"
				>
					{{ i18n.t('common.updates', 0) }}
				</MenuItem>
				<li role="separator" />
				<MenuItem
					:route="{ name: 'auth.logout' }"
					accesskey="l"
				>
					{{ i18n.t('auth.logout') }}
				</MenuItem>
			</template>
		</FlyoutMenu>
	</div>
</template>
